var map = {
	"./3d/Medal-1.png": 2790,
	"./3d/Medal-2.png": 86557,
	"./3d/Medal-3.png": 49076,
	"./default/Medal-1.png": 85556,
	"./default/Medal-2.png": 90671,
	"./default/Medal-3.png": 9126,
	"./neon/Medal-1.png": 16591,
	"./neon/Medal-2.png": 42100,
	"./neon/Medal-3.png": 75133,
	"./retro/Medal-1.png": 44163,
	"./retro/Medal-2.png": 7304,
	"./retro/Medal-3.png": 47249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37161;